import LoginForShopRequestModelBase from '../_generated/modelBases/login-for-shop-request-model-base';

export default class LoginForShopRequestModel extends LoginForShopRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
